import { Button } from '@ps/isp-web-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import replace from 'lodash/replace';
import trim from 'lodash/trim';
import React from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

import { select } from '@swf/core/store';
import { Message } from '@swf/sports/components';

import {
  TXTWCL_OopsX_Page_not_found,
  TXTWCL_Return_To_N0
} from './EventNotFoundMessage.messages.json';
import styles from './EventNotFoundMessage.scss';

const EventNotFoundMessage: React.FC<RouteComponentProps> = ({ staticContext = {} }) => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);

  staticContext.statusCode = 404;

  return (
    <Message message={<Translation {...TXTWCL_OopsX_Page_not_found} />}>
      <Button
        as={Link}
        alias="sportsAnimalRacingNext"
        values={{
          eventTypeId,
          eventTypeSlug
        }}
        className={classNames(styles.titleCase)}
      >
        <Translation
          values={{ 0: trim(replace(eventTypeSlug, /-/g, ' ')) }}
          {...TXTWCL_Return_To_N0}
        />
      </Button>
    </Message>
  );
};

export default withRouter(EventNotFoundMessage);
